import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import map from "lodash/map";
import get from "lodash/get";
import { updateMarkers } from "../../../action_managers/audio_management";
import { ControlLabel, FormControl, OverlayTrigger, Popover } from "react-bootstrap";
import { If } from "react-extras";
import loadingSpinner from "../../../icons/loading-spinner-red.svg";
import { secondsToString } from "../../../lib/numbers";
import { useComponentDidMount } from "../../../lib/hook";

const SolidBlueCircle = ({ marker, audioBlockByUUID, selectedAudioBlock = {} }) => {
  const [audioBlockUUID, setAudioBlockUUID] = useState(get(selectedAudioBlock, "uuid", ""));
  const [isLoading, setIsLoading] = useState(false);
  const [clickedSave, setClickedSave] = useState(false);

  const dispatch = useDispatch();
  const overlayRef = useRef(null);

  // reset the state of the marker if no update was made to the marker
  useComponentDidMount(() => {
    if (overlayRef.current) {
      const originalHide = overlayRef.current.handleHide;
      overlayRef.current.handleHide = () => {
        originalHide();
        if (!clickedSave) {
          setAudioBlockUUID(get(selectedAudioBlock, "uuid", ""));
        }
        setClickedSave(false);
        setIsLoading(false);
      };
    }
  }, []);

  const audioBlockItems = map(audioBlockByUUID, audioBlock => (
    <option key={audioBlock.uuid} value={audioBlock.uuid}>
      {audioBlock.name}
    </option>
  ));
  audioBlockItems.unshift(
    <option key="empty" value="">
      -- None --
    </option>
  );

  const updateMarker = () => {
    setIsLoading(true);
    setClickedSave(true);
    const markerUpdate = {
      uuid: marker.uuid,
      audioBlockUUID: audioBlockUUID,
    };
    dispatch(updateMarkers([markerUpdate]));
  };

  const popOver = (
    <Popover id={marker.uuid} className="markers-table__popover">
      <ControlLabel>AUDIO BLOCK</ControlLabel>
      <FormControl
        value={audioBlockUUID}
        onChange={e => setAudioBlockUUID(e.target.value)}
        componentClass="select">
        {audioBlockItems}
      </FormControl>
      <div className="margin-top--medium">
        <span className="redcircle-form-label">INSERTION TIME: </span>
        <span className="marker-metadata">
          {secondsToString(marker.offsetMilliSeconds / 1000, true)}
        </span>
      </div>
      <div>
        <span className="redcircle-form-label">POSITION: </span>
        <span className="marker-metadata">{marker.position}</span>
      </div>
      <If condition={!isLoading}>
        <button className="btn-link no-margin no-padding" onClick={updateMarker}>
          Save
        </button>
      </If>
      <If condition={isLoading}>
        <div className="loading-spinner-wrapper markers-table__popover-loading-spinner">
          <img src={loadingSpinner} alt="loading" className="loading-button__spinner" />
        </div>
      </If>
    </Popover>
  );

  const classNames = audioBlockUUID ? "blue-circle solid-circle" : "blue-circle";

  return (
    <OverlayTrigger
      rootClose
      delay={0}
      ref={overlayRef}
      trigger="click"
      placement="bottom"
      overlay={popOver}>
      <div id={marker.uuid} key={marker.uuid} className={classNames} />
    </OverlayTrigger>
  );
};

export default SolidBlueCircle;
